export default __webpack_public_path__ + "static/media/google_logo.6bc7d493.png";